import { MonthlyChecklistRepository } from "../../repositories/MonthlyChecklistRepository";
import { ChecklistItemEntity } from "../../entities/MonthlyChecklistEntity";

export class UpdateChecklistItemUseCase {
  constructor(private repository: MonthlyChecklistRepository) {}

  async execute(
    itemId: number,
    updates: Partial<
      Omit<
        ChecklistItemEntity,
        "id" | "checklist_id" | "created_at" | "updated_at" | "template_item_id"
      >
    >
  ): Promise<void> {
    await this.repository.updateChecklistItem(itemId, updates);
  }
}
